




















import { Component } from "vue-property-decorator";
import Loading from "@/shared/components/loading.vue";
import Modal from "@/shared/components/modal.vue";
import InputMoeda from "@/shared/components/input-moeda.vue";
import { ContaCorrenteParceirosService } from "@/services/conta-corrente-parceiros.service";
import { required } from "@/shared/validators";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
@Component({
  components: {
    Loading,
    Modal,
    InputMoeda,
  },
})
export default class Saque extends mixins(GlobalMixin) {
  idConsultor!: number;
  loading = false;
  valor = 0;
  rules = {
    valor: [required()],
  };
  async efetuar() {
    const form = this.$refs.form as any;

    if (form.validate()) {
      if (this.idConsultor == null) {
        return;
      }
      this.startLoader();
      await ContaCorrenteParceirosService.efetuarSaque(
        this.idConsultor,
        this.valor
      ).finally(this.stopLoader);
      return this.fechar(true);
    }
  }

  fechar(state = false) {
    const modal = this.$refs.modal as Modal;
    this.valor = 0;
    modal.close(state);
  }
  public async efetuarSaque(idConsultor: number) {
    const modal = this.$refs.modal as Modal;

    this.idConsultor = idConsultor;

    return modal.open();
  }
}
